import { useEffect, useRef } from 'react';
import { Box, IconButton, Paper, Typography } from '@mui/material';
import { IconX } from '@tabler/icons-react';
import ArrowLeft from 'src/icons/ArrowLeft';

import Card from './Card';

import type { IMessage } from 'src/types/Message';

type Props = { message: IMessage; onClose: () => void; mobile?: boolean };

export default function LeadDetailsPanel({ message, onClose, mobile = false }: Props) {
    const closeButton = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        closeButton.current?.focus({ preventScroll: true });
    }, [message.id]);

    return (
        <Paper
            component="section"
            aria-label="Детали лида"
            elevation={0}
            onKeyDown={(event) => {
                if (event.key === 'Escape') {
                    event.stopPropagation();
                    onClose();
                }
            }}
            sx={{
                m: mobile ? 0 : '16px 16px 0 0',
                borderRadius: mobile ? 0 : 3,
                height: mobile ? '100dvh' : 'calc(100dvh - 136px)',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                bgcolor: 'var(--lm-surface)',
                border: mobile ? 0 : '1px solid var(--lm-border)',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    p: 1.5,
                    flexShrink: 0,
                    borderBottom: '1px solid var(--lm-border)',
                }}
            >
                {mobile && (
                    <IconButton
                        ref={closeButton}
                        aria-label="Вернуться к лидам"
                        onClick={onClose}
                    >
                        <ArrowLeft />
                    </IconButton>
                )}
                <Typography
                    component="h2"
                    variant="h4"
                    sx={{ flex: 1 }}
                >
                    Детали лида
                </Typography>
                {!mobile && (
                    <IconButton
                        ref={closeButton}
                        aria-label="Закрыть детали лида"
                        onClick={onClose}
                    >
                        <IconX size={20} />
                    </IconButton>
                )}
            </Box>
            <Box
                sx={{
                    flex: 1,
                    minHeight: 0,
                    overflow: 'hidden',
                    p: 1.5,
                    pb: mobile ? 'max(24px, env(safe-area-inset-bottom))' : 2,
                }}
            >
                <Card
                    key={message.id}
                    body={message}
                    details
                />
            </Box>
        </Paper>
    );
}
